import { PricesToFetch } from 'store/price/types';
import { SearchResponse } from 'store/search/types';

const collectPricesFromSearchResults = (res: SearchResponse) => {
  const result: PricesToFetch = {};
  const { products } = res;

  if (!products) {
    return result;
  }

  products.forEach((prod) => {
    if (!result[prod.categoryId]) {
      result[prod.categoryId] = {
        categoryId: prod.categoryId,
        productIds: [],
        encryptedDesignId: '',
      };
    }

    if (result[prod.categoryId].productIds.indexOf(prod.productId) < 0) {
      result[prod.categoryId].productIds.push(prod.productId);
    }
  });
  return result;
};

export default collectPricesFromSearchResults;
